import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase/firebaseConfig";
import "../css/navBar.css";

const Navigation = () => {
  const [user, loading, error] = useAuthState(auth);
  const [username, setUsername] = useState(null);
  // State to store the screen width
  const [screenWidth, setScreenWidth] = useState(0)
  const [isToggled, setToggled] = useState(false)

  //If the user switches screen size and has the mobile menu open, it will close that mobile menu down.
  if ([screenWidth] >= 597 && isToggled) {
    setToggled(!isToggled)
  }
  // Function to toggle the class
  const toggleNav = () => {
    // This will only toggle the mobile nav if the screen size is equal to or less than 960px, which is the width the mobile navigation activates on.
    if ([screenWidth] <= 597) {
      setToggled(!isToggled)
    }
  }
  // Function to toggle the class
  const closeNav = () => {
    // This will only toggle the mobile nav if the screen size is equal to or less than 960px, which is the width the mobile navigation activates on.
    if (isToggled) {
      setToggled(!isToggled)
    }
    scrolltoTop();
  }

  // Function to update the screen width
  const updateScreenWidth = () => {
    setScreenWidth(window.innerWidth)
  }

  // useEffect hook to add and remove event listeners
  useEffect(() => {
    // Set the initial screen width
    updateScreenWidth()

    // Add event listener to update screen width on resize
    window.addEventListener("resize", updateScreenWidth)

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateScreenWidth)
    }
  }, []) // Empty dependency array ensures the effect runs once on mount

  useEffect(() => {
    const fetchUsername = async () => {
      if (user) {
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          setUsername(userDoc.data().username);
        }
      }
    };
    fetchUsername();

  }, [user]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Logout Error: ", error);
    }
  };
  useEffect(() => {
    // Close the dropdown if the user clicks outside of it
    const handleClickOutside = (event) => {
      if (!event.target.matches('.dropbtn') && window.innerWidth > 596) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }
    window.onclick = function(event) {
      if (!event.target.matches('.dropbtn') && window.innerWidth > 596) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }
    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    const dropdown = document.getElementById("myDropdown");
    dropdown.classList.toggle("show");
  };
const scrolltoTop = () => {
  document.documentElement.scrollTop = 0;
}


  return (
    
    <div className="navBar">
      <div className={isToggled ? "overlay active" : "overlay"}></div>
      <div className="navLogo" >
        <Link to={`/`} onClick={closeNav}>
          <img src="logo.png" alt="Logo" className="logo" />
        </Link>
      </div>
      <div className={isToggled ? "navButtons active" : "navButtons"}>
      <Link to={`/feed`} className="navButton" onClick={closeNav}>
              Orders
            </Link>
        {user ? (
          <>
            {/* Assuming you have fetched username into a state variable */}
            {username && <span className="navButton username">{username}</span>}
            <a onClick={handleLogout} className="navButton">
              Logout
            </a>
          </>
        ) : (
          <>
           <Link to={`/login`} className="navButton" onClick={closeNav}>
              Log In
            </Link>
            
            <div className="dropdown">
              <a onClick={toggleDropdown} className="navButton dropbtn">Sign Up</a>
              <div id="myDropdown" className="dropdown-content">
              <Link to={`/washer-signup`} className="navButton" onClick={closeNav}>
                  Washer
                </Link>
                <Link to={`/wearer-signup`} className="navButton" onClick={closeNav}>
                  Wearer
                </Link>
              </div>
            </div>  
          </>
        )}
      </div>
      <div className={isToggled ? "bars active" : "bars"} onClick={toggleNav}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        
    </div>
    
    
    
  
  );
};

export default Navigation;